(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fm-free-workouts"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root = document) {
      root.querySelectorAll('[data-fm-workout]').forEach(player => {
        if (player.dataset.ready) return;
        const button = player.querySelector('[data-fm-workout-load]');
        if (!button || !/^[A-Za-z0-9_-]{11}$/.test(player.dataset.videoId || '')) return;
        player.dataset.ready = 'true';
        button.hidden = false;
        button.addEventListener('click', () => {
          document.querySelectorAll('[data-fm-workout] iframe').forEach(other => {
            other.remove();
          });
          const frame = document.createElement('iframe');
          frame.title = player.dataset.videoTitle;
          frame.src = `https://www.youtube-nocookie.com/embed/${player.dataset.videoId}?autoplay=1&playsinline=1&rel=0`;
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          player.append(frame);
          frame.focus();
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
